export default __webpack_public_path__ + "static/media/attendance_finished_icon.d944c1e3.svg";